/* eslint-disable max-len */
import { Project } from 'components/Project/types/project';
import { ActionCreator, AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import projectService from 'services/api/customer/project-service';
import userService from 'services/api/customer/user-service';
import { RootState } from 'store';
import { ActionTypes } from 'store/project/types/state.types';
import { IClientUserDto } from 'store/user/types/client-user';

export const setProjectList: ActionCreator<AnyAction> = (payload: Project[]) => ({
  type: ActionTypes.SET_LIST,
  payload,
});

export const setListLoading: ActionCreator<AnyAction> = (payload: boolean) => ({
  type: ActionTypes.SET_LIST_LOADING,
  payload,
});

export const setUsers: ActionCreator<AnyAction> = (payload: IClientUserDto[]) => ({
  type: ActionTypes.SET_USERS,
  payload,
});

export type ThunkProjectsDispatch = ThunkDispatch<RootState, void, AnyAction>;

export const fetchProjectList = async (dispatch: ThunkProjectsDispatch) => {
  dispatch(setListLoading(true));
  try {
    const { data } = await projectService.getUsersProjects();
    dispatch(setProjectList(data.data));
    dispatch(setListLoading(false));
    return data.data;
  } catch (error) {
    dispatch(setListLoading(false));
  }
  return undefined;
};

export const fetchUsers = async (dispatch: ThunkProjectsDispatch) => {
  const { data } = await userService.getUsers();
  dispatch(setUsers(data.data));
};
